import React, { useContext, useState } from "react";
import { ShopContext } from "../../context/shop-context";
import { PRODUCTS, PRODUCTS2, PRODUCTS3 } from "../../products";
import { CartItem } from "./cart-item";
import { useNavigate } from "react-router-dom";
import Modal from "../checkout/Modal";
import { NotaItem } from "../nota/nota";
import { Address } from "../alamat/alamat";
import { AlamatIsi } from "../alamat/alamat_isi";
import { Kirim } from "../alamat/ongkir"; // Import Ongkir
import { Ongkir } from "../alamat/jasa";
import "./cart.css";

export const Cart = () => {
  const { cartItems, getTotalCartAmount } = useContext(ShopContext);
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedJasa, setSelectedJasa] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const totalAmount =
    getTotalCartAmount() +
    (selectedJasa ? Kirim.find((jasa) => jasa.name === selectedJasa).harga : 0);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleCheckout = () => {
    if (selectedAddress && selectedJasa) {
      // Lakukan proses checkout dengan alamat dan jasa yang dipilih
      console.log("Checkout with selected address and shipping service:", selectedAddress, selectedJasa);
      openModal();
    } else {
      // Hilangkan alert dan langsung lakukan checkout tanpa memilih alamat dan jasa
      openModal();
    }
  };

  const handleJasaChange = (e) => {
    const selectedJasaName = e.target.value;
    setSelectedJasa(selectedJasaName);
  };

  const bayar = () => {
    // Lakukan proses pembayaran atau tindakan lain yang dibutuhkan
    console.log("Terimakasih sudah melakukan pembelian!");

    // Tampilkan pesan terimakasih atau lakukan tindakan lain
    alert("Terimakasih sudah melakukan pembelian!");
    
    // Lakukan reload pada path=/
    navigate("/", { replace: true });
    window.location.reload();
  };


  return (
    <div className="cart">
      <br />
      <br />
      <br />
      {PRODUCTS.concat(PRODUCTS2, PRODUCTS3).map((product) => {
        if (cartItems[product.id] !== 0) {
          return <CartItem key={product.id} data={product} />;
        }
        return null;
      })}

      {totalAmount > 0 ? (
        <div className="checkout">
          <p> Subtotal: RP {totalAmount.toFixed(3)} </p>
          <button onClick={() => navigate("/")}> Continue Shopping </button>
          <button onClick={handleCheckout}> Checkout </button>

          {isModalOpen && (
            <Modal onClose={closeModal}>
              <div className="nota">
                {PRODUCTS.concat(PRODUCTS2, PRODUCTS3).map((product) => {
                  if (cartItems[product.id] !== 0) {
                    return <NotaItem key={product.id} data={product} />;
                  }
                  return null;
                })}
              </div>
              <div className="addresses">
                <h3>Pilih Alamat Pengiriman:</h3>
                <div className="select-wrapper">
                  <select
                    onChange={(e) => setSelectedAddress(e.target.value)}
                    value={selectedAddress || ""}
                  >
                    <option value="" disabled>
                      Select an Address
                    </option>
                    {Address.map((Alamat) => (
                      <option key={Alamat.id} value={Alamat.name} className="address-option">
                        {Alamat.name}
                      </option>
                    ))}
                  </select>
                  {selectedAddress && (
                    <div className="address-detail">
                      {Address.find((Alamat) => Alamat.name === selectedAddress) && (
                        <AlamatIsi
                          key={Address.find((Alamat) => Alamat.name === selectedAddress).id}
                          data={Address.find((Alamat) => Alamat.name === selectedAddress)}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="ongkir">
                <h3>Pilih Jasa Pengiriman</h3>
                <div className="select-wrapper">
                  <select
                    onChange={(e) => setSelectedJasa(e.target.value)}
                    value={selectedJasa || ""}
                  >
                    <option value="" disabled>
                      Select a Shipping Service
                    </option>
                    {Kirim.map((jasa) => (
                      <option key={jasa.id} value={jasa.name} className="address-option">
                        {jasa.name}
                      </option>
                    ))}
                  </select>
                  {selectedJasa && (
                    <div className="address-detail">
                      <Ongkir data={Kirim.find((jasa) => jasa.name === selectedJasa)} />
                    </div>
                  )}
                </div>
              </div>
              <p> Subtotal: RP {totalAmount.toFixed(3)} </p>
              <h2>Terimakasih untuk pembeliannya</h2>
              <button onClick={bayar}>Bayar</button>
            </Modal>
          )}
        </div>
      ) : (
        <h1><br />Your Shopping Cart is Empty</h1>
      )}
    </div>
  );
};
